
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 14.667l-.007-4L9.333 8l2.66-2.673L12 1.333H4v4L6.667 8 4 10.66v4.007h8zM5.333 5V2.667h5.334V5L8 7.667 5.333 5z","fill":"currentColor"}})])
          )
        }
      }
    